import birthdayIconUrl from "../dashboard/icons/birthday.svg"
import celebrationIconUrl from "../dashboard/icons/celebration.svg"
import dietaryIconUrl from "../dashboard/icons/dietary.svg"
import honeymoonIconUrl from "../dashboard/icons/honeymoon.svg"
import medicalIconUrl from "../dashboard/icons/medical.svg"
import warningIconUrl from "../dashboard/icons/warning.svg"
import { Chip, type ChipProps } from "./Chip"

export type IndicatorChipKind =
  | "allergies"
  | "anniversary"
  | "birthday"
  | "celebration"
  | "dietary"
  | "honeymoon"
  | "medical"
  | "other"
  | "specific_needs"

export type IndicatorChipData = {
  count?: number
  kind: IndicatorChipKind
}

type IndicatorChipProps = IndicatorChipData
type ChipDefinition = Omit<ChipProps, "label">

const indicatorChipVisuals = {
  allergies: {
    colorClassName: "border-[#495b6a] bg-[#f6f7f8] text-[#1d262e]",
    iconBackgroundClassName: "bg-[#cfd7de]",
    iconClassName: "h-2.5 w-2.5",
    iconSrc: medicalIconUrl,
  },
  anniversary: {
    colorClassName: "border-[#7d3c97] bg-[#f8f6f9] text-[#432051]",
    iconBackgroundClassName: "bg-[#dcc8e4]",
    iconClassName: "h-3 w-3",
    iconSrc: celebrationIconUrl,
  },
  birthday: {
    colorClassName: "border-[#7d3c97] bg-[#f8f6f9] text-[#432051]",
    iconBackgroundClassName: "bg-[#dcc8e4]",
    iconClassName: "h-3 w-3",
    iconSrc: birthdayIconUrl,
  },
  celebration: {
    colorClassName: "border-[#7d3c97] bg-[#f8f6f9] text-[#432051]",
    iconBackgroundClassName: "bg-[#dcc8e4]",
    iconClassName: "h-3 w-3",
    iconSrc: celebrationIconUrl,
  },
  dietary: {
    colorClassName: "border-[#17a88c] bg-[#f5faf9] text-[#0c5b4c]",
    iconBackgroundClassName: "bg-[#beefe5]",
    iconClassName: "h-2.5 w-[7.5px]",
    iconSrc: dietaryIconUrl,
  },
  honeymoon: {
    colorClassName: "border-[#7d3c97] bg-[#f8f6f9] text-[#432051]",
    iconBackgroundClassName: "bg-[#dcc8e4]",
    iconClassName: "h-3 w-3",
    iconSrc: honeymoonIconUrl,
  },
  medical: {
    colorClassName: "border-[#495b6a] bg-[#f6f7f8] text-[#1d262e]",
    iconBackgroundClassName: "bg-[#cfd7de]",
    iconClassName: "h-2.5 w-2.5",
    iconSrc: medicalIconUrl,
  },
  other: {
    colorClassName: "border-[#7d3c97] bg-[#f8f6f9] text-[#432051]",
    iconBackgroundClassName: "bg-[#dcc8e4]",
    iconClassName: "h-3 w-3",
    iconSrc: celebrationIconUrl,
  },
  specific_needs: {
    colorClassName: "border-[#227ebc] bg-[#f9fcfe] text-[#124466]",
    iconBackgroundClassName: "bg-[#b8daf2]",
    iconClassName: "h-3.5 w-3.5",
    iconSrc: warningIconUrl,
  },
} satisfies Record<IndicatorChipKind, ChipDefinition>

const indicatorChipLabels = {
  allergies: "Allergies",
  anniversary: "Anniversary",
  birthday: "Birthday",
  celebration: "Celebration",
  dietary: "Dietary",
  honeymoon: "Honeymoon",
  medical: "Medical",
  other: "Other",
  specific_needs: "Specific needs",
} satisfies Record<IndicatorChipKind, string>

export function IndicatorChip({ count, kind }: IndicatorChipProps) {
  return (
    <Chip
      {...indicatorChipVisuals[kind]}
      label={
        <>
          {indicatorChipLabels[kind]}
          {count ? (
            <>
              {" "}
              <span aria-hidden="true">·</span>
              {" "}
              {count}
            </>
          ) : null}
        </>
      }
    />
  )
}
